import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "lazysizes";
import "bootstrap/dist/js/bootstrap.bundle";
// ****** Styles ****** //
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./assets/sass/style.scss";
import "react-rater/lib/react-rater.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "react-image-gallery/styles/css/image-gallery.css";
import "tippy.js/dist/tippy.css";
import "react-range-slider-input/dist/style.css";
import "react-lazy-load-image-component/src/effects/blur.css";

// ****** Redux Config ****** //
import { Provider } from "react-redux";
import { store } from "./app/store";
// ****** Tools ****** //
import { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { installImageRetry } from "./utils/assetUrl";

installImageRetry();

// Cache server data: pages that were opened once re-open instantly and refresh quietly in the background
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const rootElement = document.getElementById("root");
const app = (
  <BrowserRouter>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
    <ToastContainer theme="colored" />
    <Toaster position="top-left" />
  </BrowserRouter>
);

// Pages pre-rendered at build time (react-snap) show their HTML to crawlers / before the JS arrives. The app's
// first render depends on the browser (login state, screen width ...), so it replaces that markup instead of
// hydrating it (hydration would only report mismatches and then re-render anyway).
createRoot(rootElement).render(app);

// Service worker: caches images, fonts and the hashed build files (production only)
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
